/* eslint-disable react/prefer-stateless-function, react/prop-types */
import React, { Component } from 'react';
import CoreNavigation, { actions } from '@spp/ui-core-navigation';
import { SelectedThemeProvider } from '@spp/theme-provider';
import { appConfig as config } from 'roc-package-web-app-react/app/shared/universal-config';
import { provideHooks } from 'redial';
import skin from '@vg/cn-skin-vg';
import localThemes from '../../theme';

const {
    spid: spidActions,
    coreNavigationUI: coreNavigationUIActions,
} = actions;

const engagement = ({ elementIdentifier, meta }) => {
    const { name, event } = meta;
    const href = event.target.pathname;

    try {
        const activity = window.AutoTrack.activity();
        const eventObj = activity.events.trackEngagement(
            undefined,
            undefined,
            'Click',
            'CoreNavigation',
            elementIdentifier,
            'Click',
            { name, targetUrl: href }
        );

        return new Promise(resolve => eventObj.send(resolve));
    } catch (err) {
        console.error(err); // eslint-disable-line no-console
    }

    return Promise.resolve();
};

@provideHooks({
    defer: ({ dispatch }) => dispatch(async () => {
        dispatch(coreNavigationUIActions.init(skin.sectionsMenu));

        const {
            identity,
            monetization,
        } = await dispatch(spidActions.init(config.spid));

        window.SPiD_Identity = identity;
        window.SPiD_Monetization = monetization;

        const event = new window.CustomEvent('identity-initialized', {
            detail: {
                ready: true,
            },
        });

        window.dispatchEvent(event);

        return dispatch(spidActions.subscribeEvents())
            .then(() => dispatch(spidActions.hasSession()));
    }),
})
export default class Header extends Component {
    getSectionPath() {
        const { sectionPath } = this.props.location.query;
        const { pathname } = this.props.location;

        if (pathname === '/sport/') {
            return 'sport';
        } else if (pathname === '/phoenix/sport/') {
            return 'sport';
        }

        return sectionPath;
    }

    render() {
        const publicationName = 'vg';
        const { sectionName } = this.props.location.query;

        return (
            <SelectedThemeProvider
                id={publicationName}
                whitelabelThemesMapping={{}}
                localThemesMapping={localThemes}
                irisStyles={{}}
            >
                <CoreNavigation
                    skin={skin}
                    publicationName={publicationName}
                    sectionName={sectionName}
                    sectionPath={this.getSectionPath()}
                    engagement={engagement}
                />
            </SelectedThemeProvider>
        );
    }
}



/** WEBPACK FOOTER **
 ** ./src/screens/header/index.js
 **/